import { createAction, props } from '@ngrx/store';
import { MarketingReportResponse, LeadMagnetRequest, LeadMagnetResponse } from '../../services/marketing.service';

export const loadMarketingReport = createAction(
  '[Marketing] Load Marketing Report',
  props<{ email: string }>()
);

export const loadMarketingReportSuccess = createAction(
  '[Marketing] Load Marketing Report Success',
  props<{ report: MarketingReportResponse }>()
);

export const loadMarketingReportFailure = createAction(
  '[Marketing] Load Marketing Report Failure',
  props<{ error: any }>()
);

export const clearMarketingReport = createAction(
  '[Marketing] Clear Marketing Report'
);

export const registerLeadMagnet = createAction(
  '[Marketing] Register Lead Magnet',
  props<{ request: LeadMagnetRequest }>()
);

export const registerLeadMagnetSuccess = createAction(
  '[Marketing] Register Lead Magnet Success',
  props<{ response: LeadMagnetResponse }>()
);

export const registerLeadMagnetFailure = createAction(
  '[Marketing] Register Lead Magnet Failure',
  props<{ error: any }>()
);

export const clearLeadMagnetState = createAction(
  '[Marketing] Clear Lead Magnet State'
);